
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M13 25.6c7 0 12.7-5.7 12.7-12.7C25.7 5.9 20 .2 13 .2 6 .2.3 5.9.3 12.9c0 7 5.7 12.7 12.7 12.7zm0-23.4c5.9 0 10.7 4.8 10.7 10.7 0 5.9-4.8 10.7-10.7 10.7-5.9 0-10.7-4.8-10.7-10.7C2.3 7 7.1 2.2 13 2.2z"}}),_c('path',{attrs:{"d":"M18 14l-1.8 2.3c-.3.4-.3 1.1.2 1.4.2.1.4.2.6.2.3 0 .6-.1.8-.4l3-3.9v-.1l.1-.1s0-.1.1-.1v-.1-.3-.1c0-.1 0-.2-.1-.3v-.1-.1l-3-4c-.3-.4-1-.5-1.4-.2-.4.3-.5 1-.2 1.4l1.8 2.4H6c-.6 0-1 .4-1 1s.4 1 1 1h12v.1z"}})])])
          )
        }
      }
    